import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/models/user.model';
import { CountryResponse, DepartmentResponse, TownResponse, WarehouseCategoryResponse, WarehouseRequest, WarehouseResponse } from 'src/app/models/warehouse.model';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { CatalogResponse, MeasurementsResponse } from 'src/app/models/catalog.model';
import { ProductService } from 'src/app/services/product.service';
import { Place } from 'src/app/models/place.model';
import { PlaceService } from 'src/app/services/place.service';
declare let $: any;

@Component({
  selector: 'app-modal-edit-warehouse',
  templateUrl: './modal-edit-warehouse.component.html',
  styleUrls: ['./modal-edit-warehouse.component.scss']
})
export class ModalEditWarehouseComponent implements OnInit {
  contrast = false;
  countries: CountryResponse[] = [];
  departments: DepartmentResponse[] = [];
  towns: TownResponse[] = [];
  permissionType = PermissionTypeEnum;
  catalogs: CatalogResponse;
  measurementsWeight: MeasurementsResponse[];
  department = 0;
  town = 0;
  country = 0;
  users: User[] = [];
  changedImage = false;
  @Input() warehouseId = null;
  warehouseCategories: WarehouseCategoryResponse[] = [];
  @Input() newWarehouse = new WarehouseRequest();
  loading = false;
  @Output() close = new EventEmitter<boolean>();
  loadedImage = false;
  places: Place[] = [];

  constructor(
    private warehouseService: WarehouseService,
    private placeService: PlaceService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private productService: ProductService,
    private roleService: RolesAndPermissionsService
  ) {
    this.newWarehouse.storeCategory = 1;
    this.newWarehouse.manager = 0;
  }

  ngOnInit(): void {
    this.getCountries();
    this.getUsers();
    this.getWarehouseCategories();
    this.getCatalogs();
    this.getPlaces();
  }

  selectImage() {
    $('#file').click();
  }

  changeFile(event: any) {
    const file: File = event.target.files[0];
    this.loadedImage = true;
    if (file) {
      // Convierte la imagen a una URL segura
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.newWarehouse.logo = e.target.result;
        this.calcularIntensidad(e.target.result);
        this.changedImage = true;
      };

      reader.readAsDataURL(file);
    }
  }

  calcularIntensidad(dataURL: string): number {
    const imagen = new Image();
    imagen.src = dataURL;

    let intensidadPromedio = 0;

    imagen.onload = () => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (context) {
        canvas.width = imagen.width;
        canvas.height = imagen.height;
        context.drawImage(imagen, 0, 0, imagen.width, imagen.height);

        const imageData = context.getImageData(0, 0, imagen.width, imagen.height);
        const pixels = imageData.data;
        let sumaIntensidad = 0;

        for (let i = 0; i < pixels.length; i += 4) {
          // Calcula la intensidad promedio (escala de grises)
          sumaIntensidad += (pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3;
        }

        intensidadPromedio = sumaIntensidad / (imagen.width * imagen.height);
        this.contrast = intensidadPromedio > 128;
      }
    };

    return intensidadPromedio;
  }

  getWarehouseCategories() {
    this.warehouseService.getCategoryWarehouses().subscribe({
      next: (response: ResponseObject) => {
        this.warehouseCategories = response.data;
      },
      error: (error: any) => {
        this.toastService.error("No se pudo cargar las categorias de bodega")
      }
    })
  }

  getUsers() {
    this.roleService.getUsers(parseInt(this.authService.getCurrentCompanyId())).subscribe({
      next: (response: ResponseObject) => {
        this.users = response.data;
      },
      error: (error: any) => {
        this.toastService.error("No se pudo cargar los usuarios")
      }
    })
  }

  getCountries() {
    this.warehouseService.getCountry().subscribe({
      next: (response: ResponseObject) => {
        this.countries = response.data;
        this.departments = [];
        this.getDepartments();
      },
      error: (error: any) => {
        this.toastService.error("No se pudo cargar los paises disponibles")
      }
    })
  }

  getDepartments() {
    if (!this.newWarehouse.country) {
      this.newWarehouse.country = 6;
    }
    this.warehouseService.getDepartmentsByCountry(this.newWarehouse.country).subscribe({
      next: (response: ResponseObject) => {
        this.departments = response.data;
        if (this.departments.length > 0) {
          if (!this.newWarehouse.department) {
            this.newWarehouse.department = this.departments[0].id;
          }
          this.getTowns();
        } else {
          this.towns = [];
          this.newWarehouse.town = 0;
          this.departments = [];
          this.toastService.info("No se tiene información sobre los departamentos del país elegido");
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.error(error.error.message);
        } else {
          this.toastService.error("No se pudieron obtener los departamentos");
        }
      }
    })
  }

  getTowns() {
    this.warehouseService.getTownsByDepartment(this.newWarehouse.department, this.newWarehouse.country).subscribe({
      next: (response: ResponseObject) => {
        this.towns = response.data;
        if (this.towns.length == 0) {
          this.towns = [];
          this.toastService.success("No se tiene información sobre las ciudades del departamento elegido");
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.error(error.error.message);
        } else {
          this.toastService.error("No se pudieron obtener las ciudades");
        }
      }
    })
  }

  getCatalogs(){
    this.productService.getCatalogs().subscribe({
      next: (response: ResponseObject) => {
        this.catalogs = response.data;
        this.measurementsWeight = [];
        if (this.catalogs.measurements.length >0) {
          this.catalogs.measurements.forEach(element => {
            if (element.category == 4) {
              this.measurementsWeight.push(element);
            }
          });
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getPlaces() {
    this.placeService.getPlaces().subscribe({
      next: (response: ResponseObject) => {
        this.places = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  putWarehouse() {
    this.loading = true;
    var newWarehouse = Object.assign(this.newWarehouse, {});
    newWarehouse.logo = (this.loadedImage) ? newWarehouse.logo : null;
    this.warehouseService.putWarehouse(newWarehouse, this.warehouseId).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success('Bodega editada correctamente!');
        this.loading = false;
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.toastService.error(error.error.message);
        } else {
          this.toastService.error("Error al editar la bodega");
        }
        this.loading = false;
      }
    })
  }
}
